import React from "react";
import BatchFileSelector from "./BatchFileSelector";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@mui/material";
import {
  handleComplianceOpen,
  setIsDevotionMultiple,
  submitSuccessfully,
} from "../../redux/slices/contentSlice/contentForm/contentForm";
import useUploadMasterFile from "../../hooks/useUploadMasterFile";
import { setLoading } from "../../redux/slices/apiSlice";

import useUploadContentData from "../../hooks/useUploadPosterFiles";
import { generateClient } from "aws-amplify/api";
import { createContent } from "../../graphql/mutations";
import { convertToIso6391 } from "../../helper/convertToIso";
import { toast } from "react-toastify";
import { LoadingButton } from "@mui/lab";
import ComplianceModal from "./ComplianceModal";
import SuccessModal from "./SuccessModal";
import { useNavigate } from "react-router-dom";
import IsDevotionMultiple from "./IsDevotionMultiple";
import { post } from "aws-amplify/api";

const BatchDevotionHandler = ({ formik }) => {
  const selectedItems = useSelector((state) => state.contentForm.selectedItems);
  const complianceChecked = useSelector(
    (state) => state.contentForm.complianceChecked
  );
  const complianceOpen = useSelector(
    (state) => state.contentForm.complianceOpen
  );
  const client = generateClient();
  const contentForm = useSelector((state) => state.contentForm);
  const csvBatchData = useSelector((state) => state.contentForm.csvBatchData);
  const submittedSuccessfully = useSelector(
    (state) => state.contentForm.submittedSuccessfully
  );
  const mediaType = useSelector((state) => state.contentForm.mediaType);

  const loading = useSelector((state) => state.api.loading);
  const navigate = useNavigate();
  const { uploadMasterFile } = useUploadMasterFile();
  const { uploadPosterFiles } = useUploadContentData();
  const dispatch = useDispatch();
  const handleOpen = () => dispatch(handleComplianceOpen(true));
  const handleClose = () => dispatch(handleComplianceOpen(false));
  const postOneDriveContent = async (item) => {
    try {
      const restOperation = post({
        apiName: "restapi123",
        path: "/onedriveuploader",
        options: {
          body: {
            oneDriveItems: [
              {
                filePath: item.filePath,
                downloadUrl: item.masterFile,
              },
            ],
          },
        },
      });
      const { body } = await restOperation.response;
      const response = await body.json();
      console.log("GET call succeeded: ", response);
    } catch (err) {
      console.log(err, "error");
    }
  };

  const handleBatchDevotionSubmit = async () => {
    if (!complianceChecked) {
      dispatch(handleComplianceOpen(true));
      return;
    }

    if (selectedItems.length > 0) {
      dispatch(setLoading(true));

      const uploadTasks = selectedItems.map(async (item, index) => {
        try {
            await uploadPosterFiles(item);
            const content = {
              title: csvBatchData[index]?.Title,
              synopsis: csvBatchData[index]?.["Title Synopsis"],
              type: contentForm.contentType,
              category: contentForm.category,
              director: csvBatchData[index]?.Director,
              actors: csvBatchData[index]?.Cast?.split(",").map((item) =>
                item.trim()
              ),
              duration: csvBatchData[index]?.["Duration"],
              language: csvBatchData[index]?.Language || "",
              filePath: item.filePath,
              trailerFilePath: "",
              imdbRating: csvBatchData[index]?.["IMDB Rating"],
              rottenRating: csvBatchData[index]?.["Rotten Tomatoes Rating"],
              rating: csvBatchData[index]?.["Audience Rating"],
              year: csvBatchData[index]?.Year,
              posters: [item.posterFilePath],
              
              genre: csvBatchData[index]?.Genre?.split(",").map((item) =>
                item.trim()
              ),
              isSeries: false,
              isDrmProtected: false,
              isOneDrive: false,
              agreementId: formik.values.agreementId,
            };
          if (item.typeOfFile === "local") {
            await uploadMasterFile(item);
          } else if (item.typeOfFile === "onedrive") {
            content.isOneDrive = true;
            await postOneDriveContent(item);
          }
          const response = await client.graphql({
            query: createContent,
            variables: {
              input: content,
            },
          });
          return response.data.createContent;
        } catch (error) {
          console.log(error);
          throw new Error(error.message);
        }
      });

      const results = await Promise.allSettled(uploadTasks);
      console.log(results, "results");
      const allSuccess = results.every(
        (result) => result.status === "fulfilled"
      );

      if (allSuccess) {
        dispatch(submitSuccessfully(true));
        dispatch(setIsDevotionMultiple(false));
        formik.resetForm();
      } else {
        toast.error("Some submissions failed. Please check the details.");
      }

      dispatch(setLoading(false));
    }
  };

  const handleCloseSuccessModal = () => {
    dispatch(submittedSuccessfully(false));
  };
  const handleUploadAnother = () => {
    console.log("Preparing to upload another content...");
    handleCloseSuccessModal();
  };
  const handleGoToDashboard = () => {
    navigate("/");
  };

  return (
    <div>
      {mediaType && <BatchFileSelector mediaType={mediaType} />}

      <LoadingButton
        variant="contained"
        disabled={selectedItems.length > 0 ? false : true}
        sx={{ my: 2 }}
        fullWidth
        loading={loading}
        onClick={handleBatchDevotionSubmit}
      >
        Submit Batch
      </LoadingButton>

      {!complianceChecked && (
        <ComplianceModal
          open={complianceOpen}
          handleClose={handleClose}
          formik={formik}
        />
      )}
    </div>
  );
};

export default BatchDevotionHandler;
